require('./builders/career_builder.js');
require('./builders/related_careers_builder.js');
require('./component/career_details.js');
require('./config/survey_configuration.js');
require('./functions/number_formatter_fn.js');



// WEBPACK FOOTER //
// ./app/vendor/biz-ng-career-details/src/core.ts